import { Box, Stack, Typography } from "@mui/material";
import PaypointImage from "Assets/Images/Images/moone-paypoint.svg";
import { Resources, useResource } from "Translations/Resources";
import { useState } from "react";
import { logError } from "Infrastructure/Utils/LoggingUtils";

export const NFCInstructions = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const { t } = useResource();

  return (
    <Stack gap={4} alignItems="center" height="100%">
      <Typography maxWidth={360} variant="h6" fontWeight={600}>
        {t(Resources.Merchant.InitiateDetail.NFCInstruction)}
      </Typography>
      <Box
        component="img"
        width="100%"
        maxHeight="100%"
        flex={1}
        minHeight={0}
        src={PaypointImage}
        alt="Moone paypoint"
        onLoad={() => setImageLoaded(true)}
        onError={(e) => {
          e.currentTarget.style.display = "none";
          logError(
            new Error("Failed to load paypoint image"),
            { imageSrc: PaypointImage },
            false,
          );
        }}
        sx={{
          objectFit: "contain",
          opacity: imageLoaded ? 1 : 0,
          transition: "opacity 0.3s",
        }}
      />
    </Stack>
  );
};
